import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { initial as userConditionInitial, addUserCondition } from '../redux/userConditionSlice';
import useCurrentUserId from './useCurrentUserId';

const useSetUserCondition = () => {
  const dispatch = useDispatch();
  const userConditions = useSelector((state: RootState) => state.userCondition.userConditions);
  const userId = useCurrentUserId();

  useEffect(() => {
    if (!userId || !userConditions) return;
    const id = Object.keys(userConditions).find(id => userConditions[id].userId === userId);
    if (!id) {
      console.log('*** Make new userCondition data');
      dispatch(addUserCondition({ ...userConditionInitial, userId }));
    }
  }, [userConditions])
}

export default useSetUserCondition;
